import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { SSE_EVENT_SCOREBOARD_UPDATED } from "@/constants/sse-event.constants";
import { invalidatePuzzleScoreboardCaches } from "@/helpers/invalidate-puzzle-scoreboard-caches";

/**
 * Subscribes to puzzle-scoped SSE while the scoreboard is open and refreshes comments/likes on updates.
 */
const useScoreboardSSE = (playablePropertyId: string | null | undefined, enabled: boolean): void => {
    const queryClient = useQueryClient();

    useEffect(() => {
        if (!enabled || !playablePropertyId) {
            return;
        }

        const eventSource = new EventSource(`/api/events/scoreboard/${playablePropertyId}`, {
            withCredentials: true,
        });

        eventSource.addEventListener(SSE_EVENT_SCOREBOARD_UPDATED, () => {
            invalidatePuzzleScoreboardCaches(queryClient, playablePropertyId);
        });

        eventSource.onerror = () => {
            console.error("Scoreboard SSE connection error", { playablePropertyId });
        };

        return () => {
            eventSource.close();
        };
    }, [enabled, playablePropertyId, queryClient]);
};

export default useScoreboardSSE;
